import React, {useState, useEffect} from 'react';
import { useFetch} from "../../../components/common/FetchProvider";

import {
    bankAccountReportColumn, commonReportColumn
} from "./variables/columnsData";
import ColumnsTable from "./components/ColumnsTable";
import Loader from "components/Loader/Loader";
import {getMonthNumber} from "../../../utils/utils";

const QuaterlyReports = () => {
    const fetchWrapper = useFetch();
    const [organizationId, setOrganizationId] = useState("");
    const [organizationData, setOrganizationData] = useState([]);
    const [month, setMonth] = useState("");
    const [accountId, setAccountId] = useState("");
    const [accountData, setAccountData] = useState([]);
    const [availableAccounts, setAvailableAccounts] = useState([]);
    const [error, setError] = useState(false);
    const [loading, setLoading] = useState(false);
    const baseYear = 2024; // Set your base year here
    const currentYear = new Date().getFullYear(); // Get the current year
    const [yearOption, setYearOption] = useState(currentYear.toString()); // Default to current year
    const [years, setYears] = useState([]);

    const allDropdownsSelected = organizationId && month;

    const handleYearChange = (e) => {
        setYearOption(e.target.value);
        handleOrganizationsChange(e);
    };

    const handleOrganizationsChange = (event) => {
        const selectedOrganizationId = event.target.value; // Get the selected value (id)
        setOrganizationId(selectedOrganizationId); // Update the state with the selected id
        setMonth("");
        setAccountId("");
        setAvailableAccounts([]);
        const filteredAccounts = accountData.filter(
            (account) => account.organizationId === Number(selectedOrganizationId)
        );
        setAvailableAccounts(filteredAccounts);
    };

    const handleMonthChange = (e) => {
        setMonth(e.target.value);
        setAccountId("");
    };


const reportOptions = [
    { name: "Trimestral Relação das Despesas Pagas", reportType: "quaterly-reports/despesa-report" },
    { name: "Trimestral Relação dos Recursos Recebidos", reportType: "quaterly-reports/recita-report" },
    { name: "Trimestral Balanço Mensal", reportType: "quaterly-reports/balance-report" },
  ];



    useEffect(() => {
        fetchDropdownValues();
        // Generate the year options dynamically
        const yearOptions = [];
        for (let year = baseYear; year <= currentYear; year++) {
            yearOptions.push(year);
        }
        setYears(yearOptions);
    }, [baseYear, currentYear]);

    const fetchDropdownValues = async () => {
        setLoading(true);
        try {
            let apiUrl = `${process.env.REACT_APP_API_URL}/v1/financial-management/home/dropdown`;
            const userToken = localStorage.getItem("token");
            const response = await fetchWrapper(apiUrl, {
                method: 'GET',
                headers: {
                    Authorization: `Bearer ${userToken}`,
                },
            });
            setLoading(false);
            if (response.ok) {
                const responseData = await response.json();
                if (responseData.data) {
                    setOrganizationData(responseData.data.organizations);
                    setAccountData(responseData.data.accounts);
                } else {
                    setError(true);
                }
            } else {
                setError(true);
                console.error('Error fetching API data:', response.status);
            }
        } catch (error) {
            setLoading(false);
            setError(true);
            console.error('Error fetching API data:', error);
        }
    };

    const openCommonReport= (rowData) => {    
        if (!rowData || !rowData.reportType) {
            console.error("Invalid report option selected.");
            return;
        }

        // Construct the URL dynamically based on the report type
        const url = `../${rowData.reportType}?organizationId=${organizationId}&year=${yearOption}&quarter=${month}`;
    
        // Open the dynamically constructed URL in a new tab
        const newWindow = window.open(url, '_blank', 'noopener,noreferrer');
        if (newWindow) newWindow.opener = null;
    };
    

    
    return (
        <div className="10">
            <Loader show={loading}/>

            <div className="mt-3 grid h-full grid-cols-1 gap-5 md:grid-cols-4">

                <div className="relative flex-1">
                    <select
                        value={yearOption}
                        onChange={handleYearChange}
                        className="w-full p-2.5 text-gray-800 bg-white/0 border rounded-lg shadow-sm outline-none dark:!border-white/10 dark:text-white"
                    >
                        <option value="">Select a year</option>
                        {years.map((year) => (
                            <option key={year} value={year}>
                                {year}
                            </option>
                        ))}
                    </select>
                </div>

                {/* First Dropdown */}
                <div className="relative flex-1">
                    <select
                        id="organizationId"
                        value={organizationId}
                        onChange={handleOrganizationsChange}
                        className="w-full p-2.5 text-gray-800 bg-white/0 border rounded-lg shadow-sm outline-none dark:!border-white/10 dark:text-white"
                    >
                        <option value="">Selecione o órgão</option>
                        {organizationData && organizationData.map((organization) => (
                            <option key={organization.id} value={organization.id}>
                                {organization.name}
                            </option>
                        ))}
                    </select>
                </div>

                {/* Second Dropdown */}


                {/* Third Dropdown */}
                <div className="relative flex-1">
                    <select
                        value={month}
                        onChange={handleMonthChange}
                        disabled={!organizationId}
                        className="w-full p-2.5 text-gray-800 bg-white/0 border rounded-lg shadow-sm outline-none dark:!border-white/10 dark:text-white"
                    >
                        <option value="">Selecione o trimestre</option>
                        <option value="Q1">Trimestre 1</option>
                        <option value="Q2">Trimestre 2</option>
                        <option value="Q3">Trimestre 3</option>
                        <option value="Q4">Trimestre 4</option>
                    </select>
                </div>

            </div>

            {allDropdownsSelected && (
                <div>
                    <div className="mt-10">

                        <ColumnsTable
                        columnsData={commonReportColumn}
                        tableData={reportOptions}
                        tableName="Outros Modelos"
                        onActionClick={(rowData) => openCommonReport(rowData, organizationId)}

                    />

                    </div>
                </div>
            )}
        </div>
    );
};

export default QuaterlyReports;
